import { _ as _define_property } from "@swc/helpers/_/_define_property";
import Decimal from 'decimal.js';
import * as timeModel from '~/models/time';
export class ServiceInvoiceModel {
    static fromDTO(dto) {
        var _dto_creditAmount;
        return new ServiceInvoiceModel({
            id: dto.id,
            dueDate: dto.dueDate,
            formattedNumber: dto.formattedNumber,
            pdfFile: dto.pdfFile,
            invoices: dto.invoices || [],
            quantity: new Decimal(dto.quantity),
            totalAmount: new Decimal(dto.totalAmount),
            creditAmount: new Decimal((_dto_creditAmount = dto.creditAmount) !== null && _dto_creditAmount !== void 0 ? _dto_creditAmount : '0')
        });
    }
    id() {
        return this.data.id;
    }
    formattedDueDate() {
        return timeModel.formatDate(new Date(this.data.dueDate));
    }
    rawDueDate() {
        return new Date(this.data.dueDate);
    }
    formattedNumber() {
        return this.data.formattedNumber;
    }
    quantity() {
        return this.data.quantity;
    }
    total() {
        return this.data.totalAmount;
    }
    pdfFile() {
        return this.data.pdfFile;
    }
    isPdfFileDone() {
        return this.data.pdfFile.status === 'done';
    }
    invoices() {
        return this.data.invoices;
    }
    creditAmount() {
        return this.data.creditAmount;
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
